import { isString } from "@/components/ui"

export const replaceMessage = (
  searchValue: string,
  replaceValue: number | string | { [key: string]: number | string },
  pattern = "label",
): string => {
  let result: string

  if (isString(replaceValue)) {
    result = searchValue.replace(new RegExp(`{${pattern}}`, "g"), replaceValue)
  } else {
    result = Object.entries(replaceValue).reduce(
      (prev, [pattern, value]) =>
        prev.replace(new RegExp(`{${pattern}}`, "g"), `${value}`),
      searchValue,
    )
  }

  return result
}

export const joinTel = (a?: string, b?: string, c?: string): string => {
  return (a ?? "") + "-" + (b ?? "") + "-" + (c ?? "")
}

export const joinZip = (a?: string, b?: string): string => {
  return (a ?? "") + "-" + (b ?? "")
}
